<template>
  <div>
    <main class="container-fluid">
      <section class="row">
        <div class="col-3 px-3 py-3 d-none d-md-flex"></div>

        <div class="col-24 col-md-24 col-lg-18 px-md-3 py-3 px-3 mb-md-5">
          <div class="col d-column">
            <div class="card mb-3">
              <div class="card-body py-3">
                <div class="row">
                  <div class="col-md-14">
                    <div
                      class="h-profile h-profile-lg d-flex flex-row no align-items-center"
                    >
                      <div
                        class="align-self-center d-flex align-items-center align-self-center pr-2"
                      >
                        <object
                          width="62"
                          height="62"
                          class="rounded-circle img-lg"
                          :data="program.avatar"
                          type="image/png"
                        >
                          <img
                            width="62"
                            height="62"
                            class="rounded-circle img-lg"
                            src="../../../assets/images/default.png"
                            alt="Avatar"
                          />
                        </object>
                      </div>

                      <div class="d-flex flex-column">
                        <div
                          class="d-flex align-itens-center flex-row flex-wrap"
                        >
                          <h1 class="title mt-2" v-text="program.name"></h1>
                          <VueCustomTooltip
                            v-show="program.vpn_required"
                            label="Este programa possui VPN"
                          >
                            <span class="ico ico-vpn ml-2 mt-2">
                              <img src="../../../assets/images/vpn.png" />
                            </span>
                          </VueCustomTooltip>
                          <VueCustomTooltip
                            v-show="program.nda_required"
                            label="Protegido por um NDA"
                          >
                            <span class="ico ico-nda ml-2 mt-2">
                              <img
                                src="../../../assets/icons/security-shield.svg"
                              />
                            </span>
                          </VueCustomTooltip>
                          <VueCustomTooltip
                            v-show="program.managed"
                            label="Este programa possui VPN"
                          >
                            <span class="ico ico-managed ml-2 mt-2">
                              <img src="../../../assets/images/bughunt.svg" />
                            </span>
                          </VueCustomTooltip>
                          <VueCustomTooltip
                            v-show="program.type == 'public'"
                            label="Programa Público"
                          >
                            <span class="ico ico-locked ml-2 mt-2">
                              <img
                                src="../../../../src/assets/icons/unlock.svg"
                                class="ico-13"
                              />
                            </span>
                          </VueCustomTooltip>
                          <VueCustomTooltip
                            v-show="program.type == 'private'"
                            label="Programa Privado"
                          >
                            <span class="ico ico-locked ml-2 mt-2">
                              <img
                                src="../../../../src/assets/icons/lock.svg"
                                class="ico-13"
                              />
                            </span>
                          </VueCustomTooltip>
                          <VueCustomTooltip :label="$ml.get('boostedProgram')">
                            <span
                              v-if="program.campaign_situation == 'in_progress'"
                              class="ico ico-double mt-2 ml-1"
                            >
                              <img
                                v-if="
                                  program.offers_double_bounty == true &&
                                  program.offers_double_score == true
                                "
                                src="../../../assets/icons/icon-diamante.svg"
                              />
                              <img
                                v-else-if="
                                  program.offers_double_bounty == true &&
                                  program.offers_double_score == false
                                "
                                src="../../../assets/icons/icon-double-reward.svg"
                              />
                              <img
                                v-else-if="
                                  program.offers_double_bounty == false &&
                                  program.offers_double_score == true
                                "
                                src="../../../assets/icons/icon-star.svg"
                              />
                            </span>
                          </VueCustomTooltip>
                        </div>

                        <div class="title pb-2">
                          <span
                            v-text="
                              $ml
                                .with(
                                  $utils.formatData(
                                    program.createdAt,
                                    $ml.get('ln')
                                  )
                                )
                                .get('publishedDaysAgo')
                            "
                            >Submetido há
                          </span>
                        </div>
                        <p
                          class="pb-3"
                          v-text="
                            $ml
                              .with(
                                $utils.formatData(
                                  program.updatedAt,
                                  $ml.get('ln')
                                )
                              )
                              .get('lastReviewSubmittedAgo')
                          "
                        >
                          Última revisão enviada em
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-md-10 mt-1 d-flex flex-column justify-content-between"
                  >
                    <div
                      v-if="
                        ['owner', 'administrator'].includes(
                          $store.getters['getUser'].role
                        )
                      "
                      class="align-self-end"
                    >
                      <div class="d-flex flex-lg-row ml-1">
                        <!-- hof -->
                        <div class="d-flex flex-lg-row mr-2">
                          <div class="align-self-end">
                            <div class="d-flex">
                              <div
                                @click="openHof()"
                                v-if="hallOfFame"
                                class="d-flex align-items-center pointer mb-1 mr-3"
                              >
                                <svg width="20" height="20" class="m-1">
                                  <image
                                    xlink:href="../../../assets/icons/trophy.svg"
                                    width="20"
                                    height="20"
                                  />
                                </svg>
                                <span class="title-subscribe"
                                  >Hall da Fama</span
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- hof -->

                        <div
                          v-if="bounty_severity.campaign_situation != 'pending'"
                          class="d-flex flex-lg-row"
                        >
                          <b-button
                            v-if="
                              bounty_severity.campaign_situation !=
                                'approved' &&
                              bounty_severity.campaign_situation !=
                                'in_progress' &&
                              bounty_severity.campaign_situation != 'paused' &&
                              program_status == 'in_progress'
                            "
                            v-b-tooltip.hover
                            :title="$ml.get('boostCampaign')"
                            v-b-modal.modal-1
                            class="btn btn-top mr-2"
                            style="
                              background: #e10e71;
                              border: none;
                              cursor: pointer;
                              max-width: 64px;
                              height: 35px;
                            "
                          >
                            <svg width="16" height="16" class="d-flex">
                              <image
                                xlink:href="../../../../src/assets/icons/rocket-white.svg"
                                width="16"
                                height="16"
                              />
                            </svg>
                          </b-button>
                          <ModalDoubleReward
                            :bounty_low="bounty_low"
                            :bounty_medium="bounty_medium"
                            :bounty_high="bounty_high"
                            :bounty_critical="bounty_critical"
                            :changeProgram="changeProgram"
                          />
                        </div>
                        <div
                          v-else-if="
                            bounty_severity.campaign_situation == 'pending'
                          "
                        >
                          <b-button
                            v-b-tooltip.hover
                            title="Campanha aguardando aprovação..."
                            v-b-modal.modal-1
                            class="btn btn-top mr-2"
                            style="
                              background: #c6c6c6;
                              border: none;
                              cursor: pointer;
                              height: 35px;
                            "
                          >
                            <svg width="16" height="16">
                              <image
                                xlink:href="../../../../src/assets/icons/clock-waiting.svg"
                                width="16"
                                height="16"
                              />
                            </svg>
                          </b-button>
                        </div>
                        <div class="d-flex">
                          <a
                            v-if="program.nda_required == true"
                            @click="editNDA()"
                            class="btn btn-top mr-2"
                            style="background: none; color: #730ba9 !important"
                            v-text="$ml.get('editNda')"
                            >Editar NDA
                          </a>
                          <a
                            @click="editProgram()"
                            class="btn btn-top"
                            v-text="$ml.get('editProgram')"
                            >Editar Programa</a
                          >
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="program.offers_bounty"
                      class="row mt-2 justify-content-end"
                    >
                      <div class="col-24 text-right">
                        <span class="pb-1" v-text="$ml.get('rewards')"
                          >Recompensas</span
                        >
                        <h6 v-if="program.currency === 'BRL'">
                          {{ $utils.convertMoney(program.min_bounty) }}-{{
                            $utils.convertMoney(program.max_bounty)
                          }}
                        </h6>
                        <h6 v-else-if="program.currency === 'USDT'">
                          {{ $utils.convertDollar(program.min_bounty) }}-{{
                            $utils.convertDollar(program.max_bounty)
                          }}
                        </h6>
                        <!-- <h1>{{program.currency}}</h1> -->
                      </div>
                    </div>
                    <div
                      v-if="
                        ['owner', 'administrator'].includes(
                          $store.getters['getUser'].role
                        ) && ['in_progress', 'paused'].includes(program.status)
                      "
                      class="row justify-content-end"
                    >
                      <div class="col-24 text-right">
                        <div
                          v-if="target_settings?.active && listTargets.length"
                          class="row justify-content-end"
                        >
                          <h6 class="pr-2" v-text="$ml.get('pauseProgram')">
                            Pausar programa ?
                          </h6>
                          <label class="switch">
                            <input
                              type="checkbox"
                              @click.prevent="stopProgram()"
                              :checked="status"
                            />
                            <span class="slider round"></span>
                          </label>
                        </div>
                        <div
                          v-if="!target_settings?.active"
                          class="row justify-content-end"
                        >
                          <h6 class="pr-2" v-text="$ml.get('pauseProgram')">
                            Pausar programa ?
                          </h6>
                          <label class="switch">
                            <input
                              type="checkbox"
                              @click.prevent="stopProgram()"
                              :checked="status"
                            />
                            <span class="slider round"></span>
                          </label>
                        </div>
                        <!-- <div
                          v-show="
                            program.type == 'public' &&
                            program.status == 'in_progress'
                          "
                          class="row justify-content-end"
                        >
                          <h6 class="pr-2" v-text="$ml.get('publishToTheWeb')">
                            Publicar na Web ?
                          </h6>
                          <label class="switch">
                            <input
                              type="checkbox"
                              @click.prevent="exposedProgram()"
                              :checked="program.exposed"
                            />
                            <span class="slider round"></span>
                          </label>
                        </div> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <BaseCard
              v-if="
                (bounty_severity.campaign_situation != 'finished' &&
                  bounty_severity.campaign_situation == 'paused') ||
                bounty_severity.campaign_situation == 'in_progress' ||
                bounty_severity.campaign_situation == 'approved'
              "
              :campaign_final_date="campaign_final_date"
              :campaign_initial_date="campaign_initial_date"
              :campaign_situation="campaign_situation"
              :change-program="changeProgram"
              :offers_double_bounty="offers_double_bounty"
              :offers_double_score="offers_double_score"
            />
            <div>
              <b-nav tabs>
                <b-nav-item
                  :active="menuItem === 'detail'"
                  @click="menuItem = 'detail'"
                  >{{ this.$ml.get("details") }}</b-nav-item
                >
                <b-nav-item
                  v-if="program.type == 'private'"
                  :active="menuItem === 'access'"
                  @click="menuItem = 'access'"
                  >{{ this.$ml.get("accessControl") }}</b-nav-item
                >
                <b-nav-item
                  v-if="program.type == 'private'"
                  :active="menuItem === 'credential'"
                  @click="menuItem = 'credential'"
                  >{{ this.$ml.get("credentials") }}</b-nav-item
                >
                <b-nav-item
                  :active="menuItem === 'updates'"
                  @click="menuItem = 'updates'"
                  >{{
                    this.$ml
                      .with("numberOfUpdates", programUpdates.length)
                      .get("updates")
                  }}</b-nav-item
                >
                <b-nav-item
                  v-if="
                    getUserRole === 'owner' || getUserRole === 'administrator'
                  "
                  :active="menuItem === 'config'"
                  @click="menuItem = 'config'"
                  >{{ this.$ml.get("config") }}</b-nav-item
                >
              </b-nav>
            </div>

            <div v-show="menuItem === 'detail'">
              <ProgramDetail v-if="program" :program="program" />
            </div>
            <div v-if="menuItem === 'access'">
              <HackerAccess :program="program" />
            </div>
            <div v-if="menuItem === 'updates'">
              <ProgramUpdates :programUpdates="programUpdates" />
            </div>
            <div v-if="menuItem === 'config'">
              <ConfigProgram
                :program="program"
                :managers="managers"
                @exposedProgram="exposedProgram"
                :id="id"
              />
            </div>
            <div v-if="menuItem === 'credential'">
              <CredentialHacker :program="program" />
            </div>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import $ from "jquery";
import moment from "moment";
import Swal from "sweetalert2";
import BaseCard from "../../../components/company/program/BaseCard.vue";
import ModalDoubleReward from "../../../components/company/program/modalDoubleReward.vue";
import ProgramDetail from "../../../components/programDetail";
import ProgramUpdates from "../../../components/programUpdates.vue";
import ProgramService from "../../../services/program.service";
import HackerAccess from "./hackerAccess.vue";
import ConfigProgram from "../../../components/company/program/configProgram.vue";
import CredentialHacker from "./CredentialHacker.vue";
export default {
  components: {
    ProgramDetail,
    HackerAccess,
    ProgramUpdates,
    ModalDoubleReward,
    BaseCard,
    ConfigProgram,
    CredentialHacker,
  },
  data() {
    return {
      program: false,
      id: "",
      owner: true,
      status: false,
      menuItem: "detail",
      programUpdates: [],
      bounty_severity: [],
      double_reward: 2,
      bounty_low: 0,
      bounty_medium: 0,
      bounty_high: 0,
      bounty_critical: 0,
      program_status: "",
      campaign_initial_date: "",
      campaign_final_date: "",
      campaign_situation: "",
      offers_double_bounty: false,
      offers_double_score: false,
      managers: null,
      getUserRole: "",
      hallOfFame: false,
      target_settings: [],
    };
  },

  created() {
    this.id = this.$route.fullPath.split("?")[1];
    this.changeProgram(this.$route.fullPath.split("?")[1]);
  },

  mounted() {
    this.getUserRole = this.$store.getters["getUserRole"];
    $("html, body").animate({ scrollTop: 0 }, "5000");
    this.getUpdateMessages();
  },
  destroyed() {
    this.$utils.updateTitlePage(
      "Bughunt - Plataforma De Segurança E Recompensa Por Bugs"
    );
  },
  computed: {
    listTargets() {
      return this.target_settings?.targets.filter(
        (target) => target.finishedAt === null
      );
    },
  },
  methods: {
    getUpdateMessages() {
      ProgramService.getProgramUpdates(this.id)
        .then(({ data }) => (this.programUpdates = data))
        .catch(({ response }) => console.log(response));
    },
    formartObj(data) {
      return data.map((it) => ({ ...it, join_program: true }));
    },
    changeProgram(id) {
      this.optional_rewards = [];
      ProgramService.getProgramDetail(id).then(
        (response) => {
          this.target_settings = response?.data?.target_settings;
          this.hallOfFame = response?.data?.settings?.hallOfFame;
          if (response.data.managers) {
            this.managers = this.formartObj(response.data.managers);
          }
          this.program = response.data;
          this.$utils.updateTitlePage(
            response.data.name ??
              "Bughunt - Plataforma De Segurança E Recompensa Por Bugs"
          );
          this.status = this.program.status == "paused" ? true : false;
          this.program.id = id;
          this.bounty_severity.campaign_situation =
            response.data.campaign_situation;
          this.bounty_severity.active_campaign = response.data.active_campaign;
          this.bounty_low = response.data.bounty_low;
          this.bounty_medium = response.data.bounty_medium;
          this.bounty_high = response.data.bounty_high;
          this.bounty_critical = response.data.bounty_critical;
          this.program_status = response.data.status;
          this.campaign_initial_date = moment(
            response.data?.campaign_initial_date?.toString()?.split("T")[0]
          ).format("YYYY-MM-DD");
          this.campaign_final_date = moment(
            response.data?.campaign_final_date?.toString()?.split("T")[0]
          ).format("YYYY-MM-DD");
          this.campaign_situation = response.data.campaign_situation;
          this.offers_double_bounty = response.data.offers_double_bounty;
          this.offers_double_score = response.data.offers_double_score;
        },
        () => {
          this.$router.push("/program");
        }
      );
    },

    stopProgram() {
      let self = this;
      Swal.fire({
        title: !self.status
          ? self.$ml.get("doYouWantToPauseTheProgram")
          : self.$ml.get("doYouWantToActivateTheProgram"),
        text: !self.status
          ? self.$ml.get("byPausingTheProgramExpertsWill")
          : self.$ml.get("byActivatingTheProgramSpecialistsWill"),
        confirmButtonText: !self.status
          ? self.$ml.get("pause")
          : self.$ml.get("activate"),
        cancelButtonText: self.$ml.get("cancel"),
        customClass: {
          cancelButtonText: "btn-outline-extra",
        },
        showCancelButton: true,
      }).then(function (resp) {
        if (resp.isConfirmed) {
          ProgramService.putProgramStop(self.id)
            .then(() => {
              self.changeProgram(self.id);
              Swal.fire({
                icon: "success",
                title: self.$ml.get("statusChanged"),
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              });
            })
            .catch((error) => {
              const splitMessage = error.response.data.message.split("_");
              const errorType =
                splitMessage[1] + splitMessage[2] + splitMessage[3];

              if (errorType === "programlimitexceeded") {
                const programType = splitMessage[0];
                Swal.fire({
                  icon: "info",
                  title: "",
                  text: self.$ml
                    .with(
                      "programType",
                      programType === "vdp" ? "VDP" : self.$ml.get(programType)
                    )
                    .get("typeProgramLimitExceeded"),
                });
              }
            });
        }
      });
    },

    exposedProgram() {
      let self = this;
      Swal.fire({
        title: !self.program.exposed
          ? self.$ml.get("publishProgramOnTheWeb")
          : self.$ml.get("revokeWebAccessToTheProgram"),
        text: !self.program.exposed
          ? self.$ml.get("programsPublishedOnTheWeb")
          : self.$ml.get("withoutWebAccessTheProgram"),
        confirmButtonText: !self.program.exposed
          ? self.$ml.get("publish")
          : self.$ml.get("revoke"),
        cancelButtonText: self.$ml.get("cancel"),
        showCancelButton: true,
        customClass: {
          confirmButton: "btn btn-swal",
          cancelButton: "btn btn-outline-extra",
        },
      }).then(function (resp) {
        if (resp.isConfirmed) {
          ProgramService.putProgramExpose(self.id).then(() => {
            self.changeProgram(self.id);
            Swal.fire({
              icon: "success",
              title: self.$ml.get("dataChanged"),
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            });
          });
        }
      });
    },

    editProgram() {
      this.$router.push({
        path: "/program/edit",
        name: "editProgram",
        query: {
          id: this.$route.fullPath.split("?")[1],
        },
      });
    },

    editNDA() {
      this.$router.push(
        "/program/set-nda?" + this.$route.fullPath.split("?")[1]
      );
    },

    mathAbsMoney(bounty) {
      this.bounty_severity[`${bounty}`] = Math.abs(
        this.bounty_severity[`${bounty}`]
      );
    },

    openHof() {
      window.open(
        `${window.location.origin}/hall-of-fame/${this.program.slug}`,
        "_blank"
      );
    },
  },
};
</script>
